import React from 'react';

import { formatUsd } from 'helpers';

import BaseCell from '../BaseCell';

export interface MoneyCellProps {
  /** Dollar amount (or cents/100 when passing from cents). */
  value?: number | null;
  /** When true, show cents; when false, round to dollars. Default true. */
  cents?: boolean;
  /** Passed by Row when this cell is the first column; BaseCell uses it to override end→start. */
  isFirstColumn?: boolean;
}

const MoneyCell: React.FC<MoneyCellProps> = ({ value, cents = true, isFirstColumn }) => {
  const displayValue = typeof value === 'number' ? formatUsd(value, cents) : null;

  return <BaseCell value={displayValue} align="end" isFirstColumn={isFirstColumn} />;
};

export default MoneyCell;
